import { console } from 'react-redux-app/lib/modules/core/utils';
import { handleOnEnterException } from 'react-redux-app/lib/modules/routing/utils';

import { maybeHandleCriticalError } from 'react-redux-app/lib/modules/api/utils';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';

import { actionLoadSiteStaticPagesRequest } from '../../actions/loadSiteStaticPages';

import { getLoadSiteStaticPagesError } from '../../selectors/errors';


export default ({ getState, dispatch }) => (
  function loadSiteStaticPagesHandler(nextState, successCallback, errorCallback) {
    dispatch(
      actionLoadSiteStaticPagesRequest()
    ).then(
      () => {
        if (handleOnEnterException(getState(), errorCallback, INTERNAL_ERROR_URI)) {
          return;
        }

        const error = getLoadSiteStaticPagesError(getState());
        if (
          error
          && maybeHandleCriticalError(nextState.location, error.globalErrors, errorCallback)
        ) {
          return;
        }

        successCallback();
      }
    ).catch(error => {
      console.consoleError('loadSiteStaticPagesHandler failed', error);
      errorCallback(INTERNAL_ERROR_URI);
    });
  }
);
